import React, { useEffect, useState } from 'react';
import DropDownSearch from '../../../components/DropDownSearch';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Col, Form, Row, Tooltip } from 'react-bootstrap';
import OverlayTrigger from 'react-bootstrap/OverlayTrigger';
import Modal from '../../../components/Modal';
import {
  faCircleQuestion,
  faUserTimes
} from '@fortawesome/free-solid-svg-icons';
import PropTypes from 'prop-types';
import CustomToast from '../../../components/Toast';
import moment from 'moment';
import TableSkeleton from '../../../components/SkeletonLoader/TableSkeleton';
import ToastTable from '../../../components/ToastTable';
import InfiniteScroll from 'react-infinite-scroll-component';
import { faSpinner } from '@fortawesome/pro-solid-svg-icons';
import ActivitySettings from './ActivitySettings';
import { useGetUserIdMutation } from '../../../features/authentication/dashboardHeaderApiSlice';
import { useCheckIsSelfAssignedMutation } from '../../../features/authentication/assignApiSlice';
import { useGetClassesMutation, useGetStudentsDetailsByClassesMutation } from '../../../features/authentication/authApiSlice';
import { useGetClassFilterMutation, useUpdateClassFilterMutation } from '../../../features/authentication/persistApiSlice';
import ActivityTypes from '../../../enums/activityTypes';
import { useAssignFlashCardToStudentsMutation } from '../../../features/authentication/activityApiSlice';
import { useActivityContext } from '../context';
import ConfirmationModal from '../../../components/ConfirmationPopUp';

const ActivityAssignModal = ({ modalData, setModalData }) => {
  const [classDetails, setClassDetails] = useState([]);

  const [getAllClasses] = useGetClassesMutation();
  const [getClassFilter] = useGetClassFilterMutation();
  const [updateClassFilter] = useUpdateClassFilterMutation();
  const [getAllStudents,{isLoading : studentsLoading}] = useGetStudentsDetailsByClassesMutation();
  const [assignStudents,{isLoading : assignLoading}] = useAssignFlashCardToStudentsMutation();
  const [getUserId] = useGetUserIdMutation();
  const [selectedClassIds, setSelectedClassIds] = useState([]);
  const [notAssignedData, setNotAssignedData] = useState([]);
  const [totalNotAssigned, setTotalNotAssigned] = useState(0);
  const [assignToSelf, setAssignToSelf] = useState(false);
  const [assignedResponse, setAssignedResponse] = useState([]);
  const [toastTable, setToastTable] = useState(false);
  const context = useActivityContext();
  const [checkIsAllSelfAssigned] = useCheckIsSelfAssignedMutation();
  const [isAssignToSelf, setIsAssignToSelf] = useState(false);
  const [skipValue, setSkipValue] = useState(0);
  const [userId, setUserId] = useState();
  const [showConfirmationModal, setShowConfirmationModal] = useState(false);
  const [apiParams, setApiParams] = useState({});
  const takeSize = 100;

  useEffect(() => {
    if (selectedClassIds.length > 0) {
      setSkipValue(0);
      loadInitialData(0, takeSize);
    } else {
      setNotAssignedData([]);
      setTotalNotAssigned(0);
    }
  }, [selectedClassIds]);

  const getAllClassesAsync = async () => {
    try {
      const persistIds = await getClassFilter().unwrap();
      let classes = localStorage.getItem('classes');
      if(classes)
        classes = JSON.parse(classes);
      else{
        classes = await getAllClasses().unwrap();
        localStorage.setItem('classes', JSON.stringify(classes));
      }
      const formattedClasses = classes.map((item) => ({
        id: item.classID,
        name: item.className,
        description: item.coTeacherClass ? item.teacherName : '',
        isChecked: persistIds?.includes(item.classID) ?? false
      }));
      setClassDetails(formattedClasses);
      setSelectedClassIds(persistIds ?? []);
    } catch (error) {
      console.log(error);
    }
  };

  useEffect(() => {
    if (context.assignedData.length === 1)
      context.setActivityId(context.assignedData[0].assignmentId);
    getUserIdAsync();
    getAllClassesAsync();

    if(context.isAllSelected){
      setIsAssignToSelf(true);
    }
    else{
      checkIsSelfAssigned();
    }

  }, []);

  const getUserIdAsync = async () => {
    try {
      const response = await getUserId().unwrap();
      setUserId(response.userId);
    } catch (error) {
      console.log(error);
    }
  };

  const loadInitialData = async (skip, takeSize) => {
    const { total, data } =
      (await getAllStudentsAsync(skip, takeSize)) ?? { total: 0, data: [] };
  
    setNotAssignedData(data);
    setTotalNotAssigned(total);
  };

  const handleClassSelectionChange = (e) => {
    const { key } = e;
    let tempValue = [];

    if (key === '000') {
      const selectAll = classDetails.some((item) => item?.isChecked !== true);
      tempValue = classDetails.map((item) => ({ ...item, isChecked: selectAll }));
    } else {
      const selected = classDetails.find((v) => v.id == key);
      tempValue = classDetails.map((item) =>
        item.id == key ? { ...item, isChecked: !selected.isChecked } : item
      );
    }

    setClassDetails(tempValue);
    const ids = tempValue.filter((item) => item?.isChecked === true).map((item) => item.id);
    setSelectedClassIds(ids);
    setClassIdsFilter(ids);
  };

  const setClassIdsFilter = async (ids) => {
    try {
      await updateClassFilter(ids).unwrap();
    } catch (error) {
      console.log(error);
    }
  };

  const getAllStudentsAsync = async (skip, take) => {
    try {
      const options = { classIds: selectedClassIds };
      if (skip !== undefined && skip !== '') options.skip = skip;
      if (take !== undefined && take !== '') options.take = take;

      if(context.isAllSelected)
        options.aIds = [-1];
      else if (context.assignedData.length > 0)
        options.aIds = context.assignedData.map((item) => item.assignmentId);

      if (context.assignedData.length === 1)
        context.setActivityId(context.assignedData[0].assignmentId);

      const response = await getAllStudents(options).unwrap();
      return { total: response?.total ?? 0, data: response?.data ?? [] };
    } catch (error) {
      console.log(error);
      return { total: 0, data: [] };
    }
  };

  const getStudentKey = (student) => `${student.classId}-${student.studentId}`;

  const handleChange = (e) => {
    const { name, checked } = e.target;
    let tempNotAssignedData = [];
    if (name === 'assignCheck') {
      tempNotAssignedData = notAssignedData.map((item) => {
        return { ...item, isChecked: checked };
      });
    } else {
      tempNotAssignedData = notAssignedData.map((item) =>
        getStudentKey(item) === name && !item.deleted ? { ...item, isChecked: checked } : item
      );
    }
    setNotAssignedData(tempNotAssignedData);
  };

  const handleAssignSelf = (event) => {
    const checked = event.target.checked;
    setAssignToSelf(checked);
  };

  const validateAssignmentData = async () => {
    let students = [];
    if (assignToSelf) {
      students.push({ studentId: userId, classId: selectedClassIds[0] ?? -1 });
    }
    notAssignedData
      .filter((item) => item.isChecked === true)
      .map((data) => students.push({ studentId: data.studentId, classId: data.classId }));

    if (
      !assignToSelf &&
      students.length <= 0
    ) {
      CustomToast('Please select at least one student from "Not Assigned" list.', 'info');
      return;
    }

    if (context.availabilityOption == 'FromTo') {
      const currentDate = moment().format('YYYY/MM/DD h:mm A');
      if(moment(context.startDate).isBefore(currentDate, 'day')){
        CustomToast('From Date must not be before the current day', 'error');
        return;
      }
      if(moment(context.endDate).isBefore(currentDate)){
        CustomToast('To Date must not be before the current date/time', 'error');
        return;
      }
      if(moment(context.endDate).isBefore(moment(context.startDate)) || moment(context.endDate).isSame(moment(context.startDate))){
        CustomToast('To Date must be after the From Date', 'error');
        return;
      }
    }
    let options = {
      classIds: selectedClassIds,
      studentIds: (students.length > 0 && students.length == notAssignedData.length) ? [-1] : students.map(student => student.studentId),
      students: students.length == notAssignedData.length
        ? selectedClassIds.map((classId) => ({ studentId: -1, classId }))
        : students,
      selfAssign: assignToSelf,
      availability: context.availabilityOption,
      assignmentMode: context.activityMode,
      startDate: context.startDate != '' ? moment(context.startDate).format('YYYY/MM/DD h:mm A') : '',
      endDate: context.endDate != '' ? moment(context.endDate).format('YYYY/MM/DD h:mm A') : '',
      textToSpeech: context.textToSpeech,
      studentFileUpload: context.studentFileUpload,
      randomize: context.randomized
    };

    if(context.isAllSelected){
      options.assignmentIds = [-1];
      const filters = {
        assignmentStatus : context.filters.assignmentStatus,
        courseId: context.filters.courseId,
        folderId: context.filters.folderId,
        searchText: context.filters.selectedKeyWord
      };
      options.filters = filters;
    }
    else
      options.assignmentIds = context.assignedData.map((assignment) => {
        return assignment.assignmentId;
      });
    options.activityType = ActivityTypes.FlashCard;
    setApiParams(options);
    setShowConfirmationModal(true);
  };

  const assignDataHandler = async () => {
    try {
      const response = await assignStudents(apiParams).unwrap();
      if (response.length > 0) {
        setToastTable(true);
        setAssignedResponse(response);
      } else {
        setToastTable(false);
        CustomToast('Error! Couldn\'t Assign', 'error');
      }
    } catch (ex) {
      CustomToast(ex.data.error, 'error');
      console.log(ex);
    }
    setShowConfirmationModal(false);
  };

  const checkIsSelfAssigned = async () => {
    try {
      const options = {
        assignmentIds: context.assignedData.map((item) => item.assignmentId)
      };
      const checkSelfAssignResponse = await checkIsAllSelfAssigned(options).unwrap();
      if (checkSelfAssignResponse) setIsAssignToSelf(true);
    } catch (ex) {
      console.log(ex);
    }
  };

  const nextCallback = async (newOffset) => {
    setSkipValue(newOffset);
    const { data } = await getAllStudentsAsync(newOffset, takeSize);
    let newItems = [...notAssignedData, ...data];
    let distinctData = distinctObjects(newItems);
    setNotAssignedData(distinctData);
  };

  const distinctObjects = (data) => {
    return Array.from(
      data.reduce((map, obj) => map.set(getStudentKey(obj), obj), new Map()).values()
    );
  };

  const onToastCloseHandler = () => {
    setToastTable(false);
    setModalData(false);
    context.setAssignedData([]);
    context.setAssignedDataStatus(new Date().getSeconds());
  };

  const getConfirmationText = ()=>{
    if(context.isAllSelected)
      return 'Are you sure that you want to assign <strong>all flashcards</strong> to selected students?';
    else if(context.assignedData.length > 1)
      return `Are you sure that you want to assign checked <strong>${context.assignedData.length} flashcards</strong> to selected students?`;
    return 'Are you sure that you want to assign this flashcard to selected students?';
  };

  return (
    <>
      <Modal
        contentWidth={'100%'}
        isOpen={modalData}
        titleName='Assign Flashcards to Students'
        onClose={() => setModalData(false)}
      >
        <Row>
          <Col className="col-lg-6 p-20 assign-left">
            <div className="d-flex align-items-center gap-4">
              <Form.Group style={{ width: '60%' }}>
                <Form.Label htmlFor="activityAssignClassesFilter">Class</Form.Label>
                <DropDownSearch
                  value={classDetails}
                  dropdownId="activityAssignClassesFilter"
                  placeholder="Filter Classes"
                  handleChange={(e) => handleClassSelectionChange(e)}
                  selectedId={selectedClassIds}
                  description={true}
                  selectAllText="All Classes"
                  coteacherText={true}
                />
              </Form.Group>
              {isAssignToSelf && (
                <div className="form-check d-flex align-items-center mt-4 assign-settings-header">
                  <span>
                    <input
                      className="form-check-input"
                      type="checkbox"
                      name="assignToSelf"
                      id="assignToSelf"
                      checked={assignToSelf}
                      onChange={(e) => handleAssignSelf(e)}
                    />
                    <label className="form-check-label ms-2" htmlFor="assignToSelf">
                        Assign to self
                    </label>
                  </span>
                </div>
              )}
            </div>
            <div className="my-4 gap-2">
              <span className="primary-title">Not Assigned</span> ({totalNotAssigned}){' '}
              <OverlayTrigger
                key="tooltip-notAssigned"
                placement="top"
                overlay={
                  <Tooltip id="not-assigned-info" className="not-assigned-tooltip">
                    <p>
                        The following students are in the class, but you have NOT assigned these
                        flashcards to them. To add students to the flashcards, check the box next
                        to the names and click ASSIGN.
                    </p>
                  </Tooltip>
                }>
                <FontAwesomeIcon className="circle-question" icon={faCircleQuestion} />
              </OverlayTrigger>
            </div>
            {skipValue == 0 && studentsLoading ? (
              <TableSkeleton
                rowCount={4}
                colCount={3}
                tableClass={'pt-4'}
                skeletonClass={'pt-2'} />
            ) : (
              <InfiniteScroll
                dataLength={notAssignedData.length}
                next={() => nextCallback(skipValue + takeSize)}
                hasMore={skipValue + takeSize < totalNotAssigned}
                scrollableTarget='scrollableTable'>
                <div id='scrollableTable' className="assignments-scroll-bar custom-table table-responsive not-assigned-table transparent-scroll" style={{ height: '520px', overflowY: 'auto' }}>
                  <table className="table currentlist-table">
                    <thead>
                      <tr>
                        <th className='height-unset'>
                          <div className="form-check">
                            {notAssignedData.length > 0 &&
                            <input
                              type="checkbox"
                              className="form-check-input"
                              id="assignCheck"
                              name="assignCheck"
                              checked={
                                notAssignedData.filter((item) => item?.isChecked !== true).length < 1
                              }
                              onChange={handleChange}
                            />
                            }
                          </div>
                        </th>
                        <th className='height-unset'>Last Name</th>
                        <th className='height-unset'>First Name</th>
                      </tr>
                    </thead>
                    <tbody>
                      <>
                        {notAssignedData.length > 0 ? (
                          <>
                            {notAssignedData.map((item, index) => (
                              <tr key={`${getStudentKey(item)}-${index}`}>
                                <td className='height-unset p-1'>
                                  {!item.deleted && (
                                    <div className="form-check mx-2">
                                      <input
                                        type="checkbox"
                                        name={getStudentKey(item)}
                                        checked={!!item?.isChecked}
                                        onChange={handleChange}
                                        className="form-check-input"
                                        id={`flexCheckDefault-${getStudentKey(item)}`}
                                      />
                                    </div>
                                  )}
                                  {item.deleted && (
                                    <OverlayTrigger
                                      placement="right"
                                      overlay={
                                        <Tooltip className="tooltip-white">
                                          <h4>Deactivated</h4>
                                          <p className="mb-0">
                                                Students cannot use deactivated accounts, but teacher
                                                and administrator reports do include data for these
                                                accounts{' '}
                                          </p>
                                        </Tooltip>
                                      }>
                                      <div className="deactivated">
                                        <FontAwesomeIcon icon={faUserTimes} />
                                      </div>
                                    </OverlayTrigger>
                                  )}
                                </td>
                                <td className={`${item.deleted ? 'disable-data' : ''} height-unset p-1`}>
                                  {item.lName}
                                </td>
                                <td className={`${item.deleted ? 'disable-data' : ''} height-unset p-1`}>
                                  {item.fName}
                                </td>
                              </tr>
                            ))}
                          </>
                        ) : (
                          <tr>
                            <td colSpan={3} className="fs-6 text-center">
                                  There is no more unassigned student in this class
                            </td>
                          </tr>
                        )}
                      </>
                    </tbody>
                  </table>
                  {skipValue > 0 && studentsLoading &&
                      <div className='mt-3 text-center fs-4'>
                        <FontAwesomeIcon icon={faSpinner} spin /><span className='ms-2'></span>
                      </div>
                  }
                </div>
              </InfiniteScroll>
            )}
          </Col>
          <ActivitySettings
            twoColumn={true} 
          />
        </Row>
        <div className="d-flex justify-content-end mt-3 gap-3 align-items-center">
          <button
            className="btn btn-castleGray print-btn"
            onClick={() => setModalData(false)}>
            Cancel
          </button>
          <button
            className="btn btn-castleRed print-btn"
            onClick={() => validateAssignmentData()}
            disabled={assignLoading}>
              Assign
          </button>
        </div>
        {toastTable && <ToastTable data={assignedResponse} onClose={onToastCloseHandler} title={'Flashcards'}/>}
        <ConfirmationModal
          isOpen={showConfirmationModal}
          onClose={() => setShowConfirmationModal(false)}
          onSave={() => assignDataHandler()}
          contentWidth={'35%'}
          buttonPosition={'center'}
          content={getConfirmationText()}
          cancelButton={'No'}
          confirmButton={'Yes'}
          titleName={'Assign Confirmation'}
          confirmationInProgress={assignLoading}
        />
      </Modal>
    </>
  );
};

ActivityAssignModal.propTypes = {
  modalData: PropTypes.bool,
  setModalData: PropTypes.func
};

export default ActivityAssignModal;
